





























































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { ElForm } from 'element-ui/types/form'
import { getUser } from '@/utils/cookies'
// api
import { getAllStation } from '@/api/api'
import { addUser, edit } from '@/pages/organization/api/index'
import { getUserList } from '@/pages/users/api/index'

// 公用组件
// 组织树
import SelectTree from '@/components/SelectTree/org-tree.vue'
@Component({
  name: 'AddDialog',
  components: {
    SelectTree
  }
})
export default class extends Vue {
  @Prop() private dialog!: any
  @Prop() private orgdata!:[]
  @Prop() private editdata!:{}
  @Prop() private parentid!:string
  @Prop() private parentname!:string
  private isDisable: boolean = false
  private el: any = this.$refs
  private values = ''
  private styles = {
    width: '300px'
  }
  private userData={
    parentId: '',
    name: '',
    status: true,
    sortValue: '0'

  } as any
  private isClearable=true // 可清空（可选）
  private isAccordion=true // 可收起（可选）
  // private parentInfo={
  //   valueId: '',
  //   parentName: ''
  // }
  private valueId =''
  private parentName =''
  private props={ // 配置项（必选）
        value: 'id',
        label: 'name',
        children: 'children'
        // disabled: true
      }
  private superiorData = [] // 组织负责人列表
  private formRules = {
    parentId: [{ required: true, message: '请选择上级组织', trigger: 'change' }],
    name: [{ required: true, message: '请输入组织名称', trigger: 'blur' }]
  }
  get optionData() {
      let cloneData = JSON.parse(JSON.stringify(this.orgdata)) // 对源数据深度克隆
      return cloneData.filter((father:any) => { // 循环所有项，并添加children属性
          let branchArr = cloneData.filter((child:any) => father.id === child.parentId) // 返回每一项的子级数组
          // eslint-disable-next-line no-unused-expressions
          branchArr.length > 0 ? father.children = branchArr : '' // 给父级添加一个children属性，并赋值
          return String(father.parentId) === '0' // 返回第一层
      })
    }
    @Watch('editdata')
    getUserData(val:any) {
      if (this.dialog.type !== 'add' && val.id !== undefined) {
        this.userData = val
      }
    }
    @Watch('parentid')
    getParentId(val:string) {
      this.userData.parentId = val
    }
  created() {
    this.getSuperiorData()
  }
  // 功能函数
  // 获取用户列表
  private async getSuperiorData() {
    const params = {
      status: true
    }
    const { data } = await getUserList({ })
    this.superiorData = data.data
  }
  // 添加用户
  private async addSave() {
    const { data } = await addUser(this.userData)
    if (data.isSuccess) {
      this.$message({
        message: '操作成功！',
        type: 'success'
      })
      this.$store.commit('updatedOrgTreeId', data.data.id) // 当前菜单数据存储到数据池
      this.$emit('getOrgList')
      this.handleClose()
    }
  }
  // 编辑用户
  private async updateSave() {
    delete (this.userData as any).createTime
    delete (this.userData as any).updateTime
    const { data } = await edit(this.userData)
    if (data.isSuccess) {
      this.$message({
        message: '操作成功！',
        type: 'success'
      })
      this.$store.commit('updatedOrgTreeId', data.data.id) // 当前菜单数据存储到数据池
      this.$emit('getOrgList')
      this.handleClose()
    }
  }

  // 表单提交
  private handleSubmit() {
    this.isDisable = true
    setTimeout(() => {
      this.isDisable = false // 点击一次时隔两秒后才能再次点击
    }, 2000)
    if (this.userData.parentId === '') {
      this.userData.parentId = 0
    }
    (this.$refs.ruleForm as ElForm).validate(async(valid: boolean) => {
      if (valid) {
        if (this.dialog.type === 'add') {
          await this.addSave()
        } else {
          await this.updateSave()
        }
      } else {
        return false
      }
    })
  }
  // ui
  handleNodeClick(data:Object) {
  }
  // 获取组织树id
  getValue(value: string) {
    (this.userData as any).parentId = value
  }
  // 表单取消
  private handleClose() {
    (this.$refs.ruleForm as ElForm).resetFields()
    this.$emit('cleardata')
    this.$emit('close')
  }
}
